import Swiper, { Navigation, Pagination, Controller, Scrollbar, Autoplay } from 'swiper';
Swiper.use([Navigation, Pagination, Controller, Scrollbar, Autoplay]);

export default class MediaSection {
    constructor(elm, args) {
        const isEventGallery = elm.classList.contains('media-section--event');
        const swiperElem = elm.querySelector('.swiper-container');
        const swiperModalElem = elm.querySelector('.media-section__modal .swiper-container.swiper-modal');
        const modalWrapper = elm.querySelector('.media-section__modal');
        const closeModalBtn = elm.querySelector('.modal__close');
        const amountOfSlides = swiperElem.querySelectorAll('.swiper-slide').length;

        let swiper;
        const slider = elm.querySelector('.slider');
        const modal = elm.querySelector('.modal');
        const creditContainer = elm.querySelector('[data-credit-container]');
        let interactingWithThumbnails = false;
        let interactingWithSwiper = true;
        const swiperControls = elm.querySelector('.swiper-controls');

        const options = {
            loop: amountOfSlides > 1 && !isEventGallery,
            autoHeight: true,
            spaceBetween: 20,
            centeredSlides: true,
            watchOverflow: true,
            speed: 700,
            zoom: amountOfSlides === 1,
            autoplay: isEventGallery ? false : {
                delay: 4000,
                disableOnInteraction: true,
            },
            scrollbar: {
                el: elm.querySelector('.swiper-scrollbar'),
            },
            pagination: {
                el: slider.querySelector('.swiper-pagination'),
                type: 'fraction',
                formatFractionCurrent: function (number) {
                    return (number < 10 ? '0' : '') + number;
                },
                formatFractionTotal: function (number) {
                    return (number < 10 ? '0' : '') + number;
                },
            },
            on: {
                touchStart: function () {
                    interactingWithSwiper = true;
                    interactingWithThumbnails = false;
                },
                slideChange: function (x) {
                    window.loadResource({ target: swiperElem });
                    const slide = x?.slides[x?.activeIndex];
                    if (slide && slide.dataset !== null) {
                        creditContainer.innerHTML = slide.dataset.creditText || '&nbsp;';
                    }

                    if (interactingWithSwiper) {
                        if (swiperThumbnails && swiper) {
                            swiperThumbnails.slideToLoop(swiper.realIndex, 700, false);
                        }
                    }
                },
                afterInit: function () {
                    setTimeout(() => {
                        if (swiper) {
                            swiper.update();
                        }
                    }, 100);
                },
            },
            navigation: {
                nextEl: slider.querySelector('.swiper-button-next'),
                prevEl: slider.querySelector('.swiper-button-prev'),
            },
            ...args,
        };

        const modalOptions = {
            spaceBetween: 20,
            centeredSlides: true,
            loop: amountOfSlides > 1 && !isEventGallery,
            watchOverflow: true,
            zoom: amountOfSlides === 1,
            pagination: {
                el: modal.querySelector('.swiper-pagination'),
                type: 'fraction',
            },
            navigation: {
                nextEl: modal.querySelector('.swiper-button-next'),
                prevEl: modal.querySelector('.swiper-button-prev'),
            },
            ...args,
            on: {
                touchStart: function () {
                    swiper.autoplay.stop();
                },
                sliderMove: function () {
                    swiper.autoplay.stop();
                },
                slideChange: function (x) {
                    interactingWithThumbnails = false;
                    window.loadResource({ target: swiperModalElem });
                    if (modalWrapper.classList.contains('modal--active')) {
                        const slide = x?.slides[x?.activeIndex];
                        if (slide) {
                            const video = slide.querySelector('video');
                            const iframe = slide?.querySelector('iframe');


                            if (video) {
                                if (video.readyState < 3) {
                                    video.load();
                                }
                                video.play();
                            } else if (iframe) {
                                if (!iframe.originalUrl) {
                                    iframe.originalUrl = iframe.src;
                                }
                                iframe.src = iframe.originalUrl + '&autoplay=1';
                            }
                        }

                        const prevSlide = x?.slides[x?.previousIndex];
                        if (prevSlide) {
                            const iframe = prevSlide?.querySelector('iframe');
                            const video = prevSlide.querySelector('video');
                            if (video) {
                                video.pause();
                            } else if (iframe) {
                                stopAutoplayIframe(iframe);
                            }
                        }
                    }
                },
            },
        };

        swiperControls?.addEventListener('click', () => {
            swiper.autoplay.stop();
        });

        const thumbnailsSwiperElem = elm.querySelector('.media-section__thumbnails');
        let swiperThumbnails;
        if (thumbnailsSwiperElem) {
            const thumbnailSwiperOptions = {
                loop: true,
                spaceBetween: 20,
                slidesPerView: 3,
                slideToClickedSlide: true,
                on: {
                    touchStart: function () {
                        interactingWithThumbnails = true;
                        interactingWithSwiper = false;
                    },
                    realIndexChange: function () {
                        window.loadResource({ target: thumbnailsSwiperElem });
                        if (interactingWithThumbnails) {
                            if (swiper && swiperThumbnails) {
                                swiper.slideToLoop(swiperThumbnails.realIndex, 700, false);
                            }
                        }
                    },
                },
            };

            swiperThumbnails = new Swiper(thumbnailsSwiperElem, thumbnailSwiperOptions);
            swiperThumbnails.snapGrid = [...swiperThumbnails.slidesGrid];
        }

        swiper = new Swiper(swiperElem, options);
        window.swiperls = window.swiperls ? window.swiperls : [];
        window.swiperls.push(swiper);
        const swiperModal = new Swiper(swiperModalElem, modalOptions);
        swiper.controller.control = swiperModal;
        swiperModal.controller.control = swiper;
        function stopAutoplayIframe(iframe) {
            if (!iframe.originalUrl) {
                iframe.originalUrl = iframe.src.replace('&autoplay=1', '');
            }
            iframe.src = iframe.originalUrl;
        }

        function pauseAllVideos() {
            elm?.querySelectorAll('.media-section__modal video').forEach(video => {
                video.currentTime = 0;
                video.pause();
            });

            elm?.querySelectorAll('.media-section__modal iframe').forEach(iframe => {
                stopAutoplayIframe(iframe);
            });
        }

        function autoplayIframe(iframe) {
            if (!iframe.originalUrl) {
                iframe.originalUrl = iframe.src;
            }
            iframe.src = iframe.originalUrl + '&autoplay=1';
        }

        function closeModal() {
            modalWrapper.classList.remove('modal--active');
            pauseAllVideos();
            document.body.classList.remove('modal-open');
        }
        function openModal() {
            swiper.autoplay.stop();
            modalWrapper.classList.add('modal--active');
            document.body.classList.add('modal-open');
            if (swiperModal) {
                const elem = swiperModal.slides[swiper.activeIndex];
                const video = elem?.querySelector('video');
                const iframe = elem?.querySelector('iframe');
                if (video) {
                    video.currentTime = 0;
                    video.play();
                } else if (iframe) {
                    autoplayIframe(iframe);
                }

                swiperModal.update();
            }
        }

        swiper.on('click', openModal);

        window.addEventListener('keydown', (evt) => {
            if (evt.keyCode === 27) {
                closeModal();
            }
            if (evt.keyCode === 37) {
                if (modalWrapper.classList.contains('modal--active')) {
                    swiper.slidePrev(500, null);
                }
            }
            if (evt.keyCode === 39) {
                if (modalWrapper.classList.contains('modal--active')) {
                    swiper.slideNext(500, null);
                }
            }
        });

        modal.addEventListener('click', x => {
            const dontCloseAreas = x.target.closest('.swiper-slide, picture, video, img, iframe, .swiper-controls');
            if (!dontCloseAreas) {
                closeModal();
            }
        });

        closeModalBtn.addEventListener('click', (e) => {
            e.preventDefault();
            closeModal();
        });
    }
}
